import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../../cart";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      if (data.user.role !== "admin") { setErr("This account is not an administrator."); setLoading(false); return; }
      localStorage.setItem("emporium_admin_token", data.token);
      navigate("/admin");
    } catch (e2) {
      setErr(typeof e2.response?.data?.detail === "string" ? e2.response.data.detail : "Login failed");
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6 bg-[var(--bg-primary)]">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm">
        <img src="/emporium-logo.png" alt="Emporium London" className="h-9 mb-10" />
        <h1 className="font-serif font-light text-4xl tracking-tight">Admin sign in</h1>
        <p className="mt-2 font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--text-muted)]">Authorised access only</p>
        <div className="mt-8 space-y-6">
          <div><label className="font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--text-muted)]">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full bg-transparent border-b border-black/20 py-3 focus:border-[var(--text-primary)] outline-none" /></div>
          <div><label className="font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--text-muted)]">Password</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full bg-transparent border-b border-black/20 py-3 focus:border-[var(--text-primary)] outline-none" /></div>
        </div>
        {err && <p data-testid="admin-error" className="mt-4 text-sm text-red-700">{err}</p>}
        <button data-testid="admin-login-btn" disabled={loading} className="mt-8 w-full bg-[var(--text-primary)] text-[var(--bg-primary)] h-14 font-mono text-[11px] tracking-[0.2em] uppercase hover:bg-[var(--brass)] transition-colors disabled:opacity-50">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
    </main>
  );
}
